import { Select } from '@ksyos/design-system';
import { State } from '../../../common/enums/state';
import { translateKey } from '../../translate';
import { InputText } from './common';

export interface ISelectStateProps {
    country?: string | null;
    error?: string;
    onChange: (value?: string) => Promise<void>;
    onDoValidate?: () => Promise<void>;
    placeholder?: string;
    value?: string | null;
}

export function SelectState(props: ISelectStateProps) {
    if (props.country === 'NL') {
        return (
            <Select
                error={props.error}
                onChange={(item) => props.onChange(item?.value)}
                options={getStates()}
                placeholder={props.placeholder ? props.placeholder : translateKey('common.state')}
                required={true}
                value={
                    props.value
                        ? {
                              label: props.value,
                              value: props.value,
                          }
                        : null
                }
            />
        );
    } else {
        return (
            <InputText
                fieldKey="state"
                onChange={props.onChange}
                onDoValidate={props.onDoValidate}
                placeholder={props.placeholder ? props.placeholder : translateKey('common.state')}
            />
        );
    }

    function getStates() {
        return Object.entries(State)
            .map(([, state]) => ({ label: state, value: state }))
            .sort((a, b) => a.value.localeCompare(b.value));
    }
}
